export default {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  env: process.env.REACT_APP_STAGE || 'localhost',
  taxRegistration: '100494230400003',
  amplitudeKey: process.env.REACT_APP_AMPLITUDE_KEY,
  stripeKey: process.env.REACT_APP_STRIPE_KEY || 'rk_test_51A8Xt1HLc4GztXOmT5yOgfwpOMRgo70oZAmcRjdgJS0AewCHBJuxD8LPvTW3kY5ObsRzsU1Ym863dTvNzGKoBfaZ005Sp98H6N',
};
